import request from "superagent";
import { FssSharedTypes } from "../../types";
import { getAuthHeader } from "../../utils/superagent";
import { logError } from "src/appV2/lib/analytics";

export const UpdateProfileUtils = {
  /**
   * @description use this util to Fetch PresignedURL and Upload the file to FSS
   */
  uploadProfilePicToFss: async (
    workerId: string,
    file: File,
    fileExtension: string
  ): Promise<FssSharedTypes.FssUploadResponse> => {
    // @ts-expect-error TODO(typecheck-unify): TS7053 Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ jpg: string; jpeg: string; png:
    const contentType = getContentType[fileExtension];
    if (!contentType) {
      logError("Error in UpdateProfileUtils - uploadProfilePicToFss", {
        error: new Error(`Missing contentType for fileExtension: ${fileExtension}`),
        metadata: {
          app: "Admin",
          message: "Unable to determine content type for profile picture upload",
          fileExtension,
        },
      });
      throw new Error("Invalid file extension");
    }
    const preSignedURLResponse = await request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .get(`${global.api}/agentProfile/${workerId}/profile-image-presigned-upload-url`)
      .set(await getAuthHeader())
      .query({
        extension: fileExtension,
      });
    const { presigned_url, fileStorageFileKey } = preSignedURLResponse.body;
    await request.put(presigned_url).set("Content-Type", contentType).send(file);
    return { fileStorageFileKey };
  },
};

export const getContentType = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  potx: "application/vnd.openxmlformats-officedocument.presentationml.template",
  ppsx: "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  odt: "application/vnd.oasis.opendocument.text",
  ods: "application/vnd.oasis.opendocument.spreadsheet",
  odp: "application/vnd.oasis.opendocument.presentation",
  rtf: "application/rtf",
  csv: "text/csv",
  txt: "text/plain",
};
